export default __webpack_public_path__ + "static/media/coin_dai.2ea7bfbd.svg";